/** @file Depth change per unit of screen-up along a quad, by sheer (design 15.2: sheer moves depth only). */
import { degToRad } from '@zilo/pose3d-math/angle/degToRad';
import { clamp } from '@zilo/pose3d-std/math/clamp';

/** `s = clamp(sheer, 0, 2)`: `-tan(e) (1 - s)` up to 1 (upright nears toward its top), `cot(e) (s - 1)` above. */
export function depthSlopeOf(sheer: number, pitchDeg: number): number {
  const s = clamp(sheer, 0, 2);
  const e = degToRad(pitchDeg);
  return s <= 1 ? -Math.tan(e) * (1 - s) : (s - 1) / Math.tan(e);
}
